<template>
  <v-card class="elevation-0">
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>اعلانات</h4></v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list style="max-height: 320px;overflow-y: auto" two-line class="pa-0">
        <template v-for="(item, index) in items">
          <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-list-tile avatar v-else :key="index" @click="$router.push(item.link)">
            <v-list-tile-avatar :color="item.color">
              <v-icon dark>{{item.icon}}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title v-html="item.title"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="caption pr-2">
              <small style="direction: ltr">{{item.timeLabel}}</small>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-divider></v-divider>
      <v-btn block flat class="ma-0" @click="seenAll">همه را خواندم</v-btn>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import JDate from 'jalali-date';
export default {
  data: () => ({
    items: [],
    lastId: 0,
  }),
  created: function () {
    setInterval(this.getNotifications, 18000);
  },
  methods: {
    getNotifications: function () {
      this.axios.get('/reseller/notifications')
        .then(response => {
          if (typeof response.data.Data === 'undefined') {
            return;
          }
          this.items = [];
          this.$emit('change', response.data.Data.length);
          response.data.Data.forEach(item => {
            this.lastId = item.id;
            this.items.push({
              title: item.title,
              link: item.link,
              color: 'light-green',
              icon: 'notification_important',
              timeLabel: '(' + this.toJalali(item.created_at) + ')',
            });
            this.items.push({ divider: true, inset: true });
          });
        }).catch(error => {
          console.log(error);
        });
    },
    seenAll: function () {
      this.axios.get('/reseller/seen_notifications/' + this.lastId)
        .then(() => {
          this.items = [];
          this.$emit('change', 0);
        }).catch(error => {

        });
    },
    toJalali: function (jd) {
      // 2019-07-08T10:54:22+04:30
      let splittedDate = jd.split('T');
      let date_1 = splittedDate[0].split('-');
      const d = new JDate(new Date(date_1[0], date_1[1], date_1[2]));
      return this.toPersianDigit(d.format('YYYY-MM-DD  ') + splittedDate[1].replace('+04:30', '', -1));
    },
    toPersianDigit: function (input, toEnglish) {
      if (typeof input !== 'string') {
        input = input.toString();
      }
      let dg = [
        ['۰', '0'],
        ['۱', '1'],
        ['۲', '2'],
        ['۳', '3'],
        ['۴', '4'],
        ['۵', '5'],
        ['۶', '6'],
        ['۷', '7'],
        ['۸', '8'],
        ['۹', '9']
      ];
      if (typeof toEnglish === 'undefined') {
        toEnglish = false;
      }
      if (toEnglish) {
        for (let i = 0; i <= 9; i++) {
          input = input.replace(new RegExp(dg[i][0], 'g'), dg[i][1]);
        }
        return input;
      }
      for (let i = 0; i <= 9; i++) {
        input = input.replace(new RegExp(dg[i][1], 'g'), dg[i][0]);
      }
      return input;
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/widgets/list/NotificationList.vue